import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import ErrorPage from "./error-page";
import {
  AdminPanel,
  Customers,
  Dashboard,
  Finance,
  History,
  Login,
  Cash,
  RecieveFactor,
  Search,
  SpendFactor,
  Chat,
} from "../pages";
import { SearchCash, SearchCheque, SearchFactor } from "../pages/search";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/admin",
        element: <AdminPanel />,
      },
      {
        path: "/customers",
        element: <Customers />,
      },
      {
        path: "/chat",
        element: <Chat />,
      },
      {
        path: "/history",
        element: <History />,
      },
      {
        path: "/search",
        element: <Search />,
        children: [
          {
            path: "/search",
            element: <SearchCheque />,
          },
          {
            path: "/search/factor",
            element: <SearchFactor />,
          },
          {
            path: "/search/cash",
            element: <SearchCash />,
          },
        ],
      },
      {
        path: "/financial",
        element: <Finance />,
        children: [
          {
            path: "/financial",
            element: <RecieveFactor />,
          },
          {
            path: "/financial/spend-factor",
            element: <SpendFactor />,
          },
          {
            path: "/financial/cash",
            element: <Cash />,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);

export default router;
